<template>
  <section class="hero">
    <div class="h25-container hero-inner">
      <div class="eyebrow">Shenzhen · AI Technology Enabler</div>
      <h1>让技术更好<br>服务社会</h1>
      <p class="desc">产品内容持续输出 · 全程支撑/赋能 · 实施运维交付兜底。<br>联合生态渠道伙伴，整合本地化资源与AI落地技术能力，<br>一站式交付园区、制造、政务AI数字化服务。</p>
      <div class="hero-btns">
        <span class="h25-btn-primary" @click="goAnchor('contact')">合作咨询</span>
        <span class="h25-btn-ghost" @click="goAnchor('platform')">了解赋能中台</span>
      </div>
    </div>
  </section>
</template>
<script>export default { name: 'HeroSection', inject:['goAnchor'] }</script>
<style scoped>
.hero { min-height: 85vh; display: flex; align-items: center; padding-top: 64px; }
.hero-inner { max-width: 760px; }
.eyebrow { font-size: 12px; text-transform: uppercase; letter-spacing: 3px; color: var(--h25-muted); margin-bottom: 28px; font-weight: 600; }
.hero h1 { font-size: clamp(42px,7vw,76px); line-height: 1.1; font-weight: 700; letter-spacing: -2px; margin-bottom: 28px; color: var(--h25-text); }
.desc { font-size: 18px; color: var(--h25-text2); max-width: 580px; line-height: 1.75; margin-bottom: 40px; }
.hero-btns { display: flex; gap: 14px; flex-wrap: wrap; }
@media (max-width:768px){ .hero{ min-height:70vh; } }
</style>
